export default [{
  path: '/type-expense',
  name: 'type_expense',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/typeExpense/index')
}]
